
import Card from '../../../components/base/Card';

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "Sarah Leroy",
      location: "Paris",
      rating: 5,
      comment: "Grâce à Marie, j'ai perdu 15kg en 6 mois ! Son approche personnalisée et sa motivation m'ont permis d'atteindre mes objectifs. Je recommande vivement !",
      image: "https://public.readdy.ai/ai/img_res/bb95d93c04a58628c5759ed04280b486.jpg"
    },
    {
      name: "Marc Dubois",
      location: "Lyon",
      rating: 5,
      comment: "Thomas m'a aidé à retrouver ma forme après une blessure. Ses séances de yoga thérapeutique ont été parfaites pour ma rééducation. Excellent coach !",
      image: "https://readdy.ai/api/search-image?query=Satisfied%20male%20client%20in%20recovery%20showing%20positive%20fitness%20results%2C%20middle-aged%20man%20smiling%20confidently%20after%20successful%20rehabilitation%20training%2C%20natural%20lighting%2C%20authentic%20testimonial%20portrait&width=80&height=80&seq=client-2&orientation=squarish"
    },
    {
      name: "Julie Martin",
      location: "Marseille",
      rating: 5,
      comment: "Sophie est incroyable ! Ses cours de HIIT sont intenses mais tellement efficaces. J'ai gagné en endurance et en confiance en moi. Merci !",
      image: "https://readdy.ai/api/search-image?query=Energetic%20female%20fitness%20enthusiast%20showing%20great%20results%20from%20training%2C%20young%20woman%20with%20athletic%20build%20smiling%20proudly%2C%20bright%20gym%20environment%2C%20successful%20transformation%20testimonial%20photography&width=80&height=80&seq=client-3&orientation=squarish"
    }
  ];

  const renderStars = (rating: number) => {
    const stars = [];
    for (let i = 0; i < rating; i++) {
      stars.push(<i key={i} className="ri-star-fill text-yellow-400"></i>);
    }
    return stars;
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Ce que disent nos clients
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez les témoignages de nos clients qui ont transformé leur vie grâce à nos coachs
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {renderStars(testimonial.rating)}
              </div>
              
              <p className="text-gray-700 italic">"{testimonial.comment}"</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
